import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState({
    name: 'Cecilia H.',
    city: 'San Luis',
    product: 'Pack Completo Física + Química',
    time: '6'
  });
  const names = ['Cecilia H.', 'Martín G.', 'Laura P.', 'Diego R.', 'Ana M.', 'Carlos S.', 'Lucía F.', 'Pablo T.'];
  const cities = ['San Luis', 'Córdoba', 'Rosario', 'Mendoza', 'CABA', 'Tucumán', 'Salta', 'Neuquén', 'Santa Fe'];
  const products = ['Pack Completo Física + Química', 'Pack Completo Física + Química', 'Física Lista', 'Química Lista'];
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomNotification = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    const randomProduct = products[Math.floor(Math.random() * products.length)];
    const randomTime = Math.floor(Math.random() * 15) + 2;
    setCurrentNotification({
      name: randomName,
      city: randomCity,
      product: randomProduct,
      time: randomTime.toString()
    });
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 15000) + 15000;
      setTimeout(() => {
        showRandomNotification();
      }, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-285">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-brand-card rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-brand-border p-3 max-w-[260px] pointer-events-none" data-id="element-286">
          <div className="flex items-start gap-3" data-id="element-287">
            <div className="bg-brand-accent/10 p-1.5 rounded-full mt-0.5 border border-brand-accent/20" data-id="element-288">
              <CheckCircle2 className="text-brand-accent" size={14} data-id="element-289" />
            </div>
            <div data-id="element-290">
              <div className="text-[10px] font-bold text-brand-accent uppercase tracking-widest mb-1" data-id="element-291">
                Compra verificada
              </div>
              <div className="text-xs text-white leading-tight mb-0.5" data-id="element-292">
                <span className="font-bold" data-id="element-293">{currentNotification.name}</span> de{' '}
                {currentNotification.city}
              </div>
              <div className="text-[11px] text-white/60 leading-tight mb-1.5" data-id="element-294">
                compró{' '}
                <span className="font-bold text-white" data-id="element-295">
                  {currentNotification.product}
                </span>{' '}
                🔬
              </div>
              <div className="text-[10px] text-white/40 italic font-medium" data-id="element-296">
                hace {currentNotification.time} minutos
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}